// datoric — GET /api/datoric/health (public liveness probe).
import { z } from 'zod';

export const DatoricHealthResSchema = z.object({
  ok: z.literal(true),
  project: z.literal('datoric'),
  ts: z.string(),
});
export type DatoricHealthRes = z.infer<typeof DatoricHealthResSchema>;
